import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { Select } from 'components/fields'
import { Button } from 'components/misc'
import { Section } from 'components/layout'
import { form } from 'helpers/decorators'

@form({
  form: 'form-participant-state'
})
class OrganizationStateChange extends PureComponent {
  static propTypes = {
    data: PropTypes.object,
    values: PropTypes.object,
    loading: PropTypes.bool,
    organizationStates: PropTypes.array,
    modal: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    updateOrganizationState: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired
  }

  componentWillMount() {
    const { data } = this.props

    this.props.initialize({
      organizationState: get(data, 'organizationState')
    })
  }

  render() {
    const {
      data,
      values,
      organizationStates,
      handleSubmit,
      loading
    } = this.props

    return (
      <Section>
        <form
          onSubmit={handleSubmit(fields =>
            this.props.updateOrganizationState(data.id, fields)
          )}
        >
          <div className="row">
            <div className="col-xs-12">
              <Select
                name="organizationState.value"
                label="State"
                intlKey="label.state"
                options={organizationStates}
              />
            </div>
          </div>
          <div className="base-margin--top">
            <div className="row">
              <div className="col-xs-6">
                <Button
                  type="button"
                  intlKey="button.close"
                  secondary
                  onClick={() => this.props.modal(null)}
                >
                  Close
                </Button>
              </div>
              <div className="col-xs-6 text--right">
                <Button
                  intlKey="button.change_state"
                  isLoading={loading}
                  disabled={
                    get(values, 'organizationState.value') ===
                    get(data, 'organizationState.value')
                  }
                >
                  Change state
                </Button>
              </div>
            </div>
          </div>
        </form>
      </Section>
    )
  }
}

export default OrganizationStateChange
